import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaMapMarkerAlt, FaFileContract, FaLaptopHouse } from 'react-icons/fa';
import { CONTRACT_TYPES, WORKPLACE_OPTIONS, optionLabel } from './careersOptions';

// Contract · location · workplace line shown on job cards and the job page
const JobMeta = ({ job }) => {
  const { i18n } = useTranslation();
  const lang = i18n.language === 'en' ? 'en' : 'fr';
  // First version of offers stored the workplace as "remote"
  const workplace = job.workplace || job.remote;

  return (
    <ul className="job-meta">
      {job.contractType && <li><FaFileContract /> {optionLabel(CONTRACT_TYPES, job.contractType, lang)}</li>}
      {job.location && <li><FaMapMarkerAlt /> {job.location}</li>}
      {workplace && <li><FaLaptopHouse /> {optionLabel(WORKPLACE_OPTIONS, workplace, lang)}</li>}
    </ul>
  );
};

export default JobMeta;
